import * as React from 'react';
import { Button, Table } from '@rtkwlf/ui';
import Icon from '../../../../widgets/Icons';
import { ROUTE_PATH } from '../../../../constants';
import Panel from '../../../../widgets/Panel';
import { PageTitle } from '../../../../widgets/PageTitle';
import Viewport from '../../../../widgets/Viewport';
import ErrorJumbotron from '../../../../widgets/ErrorJumbotron';
import { useDeleteCredential } from './useDeleteCredential';
import { useColumns } from './useColumns';
import { useFetchCredentials } from './useFetchCredentials';
import { useRedirectCallback } from '../../../../hooks';
import { ConnectedAccountPageHeader } from '../ConnectedAccountPageHeader';

const ConnectedAccountListView = () => {
  const {
    credentials,
    error: credentialsError,
    isLoading: isLoadingCredentials,
    getCredentialsLists,
  } = useFetchCredentials();

  const onAdd = useRedirectCallback(
    ROUTE_PATH.SELF_SERVICE.CONNECTED_ACCOUNTS.MAIN + '/new',
  );

  const { modal, onConfirmDelete } = useDeleteCredential(getCredentialsLists);
  const columns = useColumns(onConfirmDelete);

  let emptyComponent: React.ReactNode;
  if (isLoadingCredentials) {
    emptyComponent = 'Loading connected accounts...';
  } else if (credentialsError) {
    emptyComponent = <ErrorJumbotron error={credentialsError} />;
  } else if (credentials.length === 0) {
    emptyComponent = (
      <span>
        Select
        <Button
          type="link"
          className="d-inline px-1 font-normal"
          onClick={onAdd}
        >
          Add Account
        </Button>
        to connect an account
      </span>
    );
  }

  return (
    <Viewport>
      <PageTitle title="Connected Accounts" />
      <ConnectedAccountPageHeader title="Connected Accounts" />
      <Panel className="horizontal-overflow">
        <div className="d-flex">
          <Button
            data-cy="add-account"
            className="add-account ml-auto mb-3"
            ghost={credentials.length > 0}
            onClick={onAdd}
          >
            <span>
              <Icon.Plus className="mr-1" />
              Add Account
            </span>
          </Button>
        </div>
        <Table
          className="connected-account-table"
          columns={columns}
          data={credentials}
          dataUniqueKey="value"
          emptyComponent={emptyComponent}
        />
        {modal}
      </Panel>
    </Viewport>
  );
};

export default ConnectedAccountListView;
